import Header from "features/header/Header";
import Skills from "features/skills/Skills";
import Experience from "features/experience/Experience";
import Projects from "features/projects/Projects";
import Education from "features/education/Education";
import Contact from "features/contact/Contact";
import Cover from "features/cover/Cover";
import Social from "features/social/Social";

const Home = () => {
  return (
    <section className="home_page flex flex-col p-2 md:p-12 gap-y-36">
      <Header />
      <Skills />
      <Experience />
      <Projects />
      <Education />
      <Contact />
      <Cover />
      <Social />
    </section>
  );
};

export default Home;
